// =====================================================================
// ESTILO DE IMPRESIÓN QUE LA CSP NO TIRA · 19 de septiembre de 2026
// =====================================================================
// El ticket de venta, el gafete de operador y la cinta de etiquetas
// inyectaban un `<style>` mientras el componente vivía. Desde que nginx
// manda `style-src-elem 'self'` (frontend/nginx.conf), el navegador lo
// RECHAZA en silencio —solo lo dice la consola— y al imprimir salía la
// pantalla entera con el modal, no el cartón. Lo midió la auditoría de
// botones del 19 de septiembre de 2026 al pulsar «Imprimir gafete».
//
// Una hoja CONSTRUIDA (`new CSSStyleSheet()` + `adoptedStyleSheets`) es
// CSSOM, no un elemento: la CSP no la mira, y hace exactamente lo mismo.
// Donde no exista (navegadores viejos) se vuelve al `<style>` de antes,
// que allí sí entra porque esos navegadores tampoco aplican esa directiva.
import { useEffect } from 'react';

/** Aplica el CSS y devuelve la función que lo retira. */
export function aplicarEstilo(css) {
  if (typeof document === 'undefined') return () => {};
  const puedeConstruir = typeof CSSStyleSheet !== 'undefined'
    && 'adoptedStyleSheets' in document
    && typeof CSSStyleSheet.prototype.replaceSync === 'function';
  if (puedeConstruir) {
    try {
      const hoja = new CSSStyleSheet();
      hoja.replaceSync(css);
      document.adoptedStyleSheets = [...document.adoptedStyleSheets, hoja];
      return () => { document.adoptedStyleSheets = document.adoptedStyleSheets.filter((h) => h !== hoja); };
    } catch { /* se cae al <style> */ }
  }
  const estilo = document.createElement('style');
  estilo.textContent = css;
  document.head.appendChild(estilo);
  return () => { estilo.remove(); };
}

/** El estilo vive mientras el componente vive. */
export function useEstiloDeImpresion(css) {
  useEffect(() => aplicarEstilo(css), [css]);
}
